import { EventEmitter, Injectable } from '@angular/core';
import { Loading } from '../../types/utils';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SpinnerService {
    private loading: Loading;
    private pending = 0;
    private spinning$ = new EventEmitter<Loading>();

    constructor() {}

    resetSpinner(): void {
        this.pending = 0;
        this.loading = { loadingStatus: false, loadingMessage: '', pending: this.pending };
        this.spinning$.emit(this.loading);
    }

    public showSpinner(message = ''): void {
        this.pending++;
        this.loading = { loadingStatus: true, loadingMessage: message, pending: this.pending };
        this.spinning$.emit(this.loading);
    }

    public hideSpinner(message = ''): void {
        if (this.pending > 0) {
            this.pending--;
        }
        if (this.pending === 0) {
            this.loading = { loadingStatus: false, loadingMessage: message, pending: this.pending };
            this.spinning$.emit(this.loading);
        }
    }

    public getLoadingStatus(): Observable<Loading> {
        return of(this.loading);
    }
}
